var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 33C23.5858 33 23.25 33.3358 23.25 33.75C23.25 34.1642 23.5858 34.5 24 34.5C24.4142 34.5 24.75 34.1642 24.75 33.75C24.75 33.3358 24.4142 33 24 33",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21C18 17.6863 20.6863 15 24 15C27.3137 15 30 17.6863 30 21C30 24.3137 27.3137 27 24 27",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 24C46.5002 20.7296 44.3817 17.8359 41.264 16.848C42.7706 13.9456 42.2231 10.4016 39.9107 8.08929C37.5984 5.77696 34.0544 5.22939 31.152 6.73601C30.1646 3.61781 27.2708 1.49872 24 1.49872C20.7292 1.49872 17.8354 3.61781 16.848 6.73601C13.9456 5.22939 10.4016 5.77696 8.08929 8.08929C5.77696 10.4016 5.22939 13.9456 6.73601 16.848C3.61781 17.8354 1.49872 20.7292 1.49872 24C1.49872 27.2708 3.61781 30.1646 6.73601 31.152C5.22939 34.0544 5.77696 37.5984 8.08929 39.9107C10.4016 42.2231 13.9456 42.7706 16.848 41.264C17.8354 44.3822 20.7292 46.5013 24 46.5013C27.2708 46.5013 30.1646 44.3822 31.152 41.264C34.0544 42.7706 37.5984 42.2231 39.9107 39.9107C42.2231 37.5984 42.7706 34.0544 41.264 31.152C44.3813 30.1636 46.4996 27.2703 46.5 24Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.25,
    y1: 33,
    x2: 24.25,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 24,
    y1: 15,
    x2: 24,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.9994,
    y1: 1.49872,
    x2: 23.9994,
    y2: 46.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.937196d0f4e88c8667ddf45572a2916f.svg";
export { ForwardRef as ReactComponent };